import { QUERY_KEYS } from 'api/query-keys';
import { sharedPaymentService } from 'api/services';
import { useInfiniteQuery } from 'react-query';
import { Site } from 'shared/hooks';
import { DEFAULT_PAGE_SIZE } from 'shared/utils/constants';
import { PaymentUsersFilters } from './use-payment-users.types';

export const useGetPaymentUsers = (site: Site, filters: PaymentUsersFilters) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.paymentUsers(filters),
    queryFn: async ({ pageParam = 0 }) =>
      await sharedPaymentService.getPaginatedPaymentUsers(
        site,
        pageParam,
        DEFAULT_PAGE_SIZE,
        filters
      ),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};
